enum Theme {
  DEFAULT = 'default',
  DARK = 'dark',
  AUTO = 'auto',
  MATRIX = 'matrix'
}

export default Theme
